import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { IMasterDTO, MasterModel } from "../models/list/master";
import { DetailModel, IDetailDTO } from "../models/list/detail";
import { getTenantId } from "../helper";
import { plainToClass } from "class-transformer";
let ListManagerModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    let ListManagerModule = class ListManagerModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.masters = [];
            this.master = { id: null, masterName: "", itemsFound: 0, showInListManager: true, sortingProperty: "" };
            this.details = [];
            this.detail = { id: null, code: "", description: "", masterId: null, sortingProperty: "" };
            this.apiNode = "Applist";
        }
        async GetMasters() {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetMasters(data.masters);
            }
            return [];
        }
        SetMasters(masters) {
            this.masters = masters;
        }
        async AddMaster(newListName) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, newListName);
            if (data) {
                this.SetAddMaster(data.master);
                return data;
            }
        }
        SetAddMaster(master) {
            this.masters.push(master);
        }
        async UpdateMaster(updateListName) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.put(url, updateListName);
            if (data) {
                this.SetUpdateMaster(data.master);
                return data;
            }
        }
        SetUpdateMaster(master) {
            var that = this;
            var target = that.masters.findIndex((x) => x.id == master.id);
            if (target !== -1) {
                that.masters[target] = plainToClass(MasterModel, master);
            }
            else {
                that.masters.push(plainToClass(MasterModel, master));
            }
            that.masters = [...that.masters];
        }
        async GetDetails(masterId) {
            var url = `${getTenantId()}/${this.apiNode}/` + masterId + `/details`;
            let { data } = await service.get(url);
            if (data) {
                this.SetDetails(data.details);
            }
            return [];
        }
        SetDetails(details) {
            this.details = details;
        }
        async AddDetail(listItem) {
            var url = `${getTenantId()}/${this.apiNode}/` + listItem.masterId + `/details`;
            let { data } = await service.post(url, listItem);
            if (data) {
                this.SetAddDetail(data.detail);
                return data;
            }
        }
        SetAddDetail(detail) {
            this.details.push(detail);
        }
        async UpdateDetail(detail) {
            var url = `${getTenantId()}/${this.apiNode}/` + detail.masterId + `/details`;
            let { data } = await service.put(url, detail);
            if (data) {
                this.SetUpdateDetail(data.detail);
                return data;
            }
        }
        SetUpdateDetail(detail) {
            var that = this;
            var target = that.details.findIndex((x) => x.id == detail.id);
            if (target !== -1) {
                that.details[target] = plainToClass(DetailModel, detail);
            }
            else {
                that.details.push(plainToClass(DetailModel, detail));
            }
            that.details = [...that.details];
        }
        async DeleteMaster(masterId) {
            var url = `${getTenantId()}/${this.apiNode}/` + masterId + `/DeleteMaster`;
            let { data } = await service.delete(url);
            return data;
        }
        async DeleteDetail(detailId) {
            var url = `${getTenantId()}/${this.apiNode}/` + detailId + `/DeleteDetail`;
            let { data } = await service.delete(url);
            return data;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], ListManagerModule.prototype, "GetMasters", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ListManagerModule.prototype, "SetMasters", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof MasterModel !== "undefined" && MasterModel) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], ListManagerModule.prototype, "AddMaster", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof IMasterDTO !== "undefined" && IMasterDTO) === "function" ? _d : Object]),
        __metadata("design:returntype", void 0)
    ], ListManagerModule.prototype, "SetAddMaster", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof MasterModel !== "undefined" && MasterModel) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], ListManagerModule.prototype, "UpdateMaster", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof IMasterDTO !== "undefined" && IMasterDTO) === "function" ? _g : Object]),
        __metadata("design:returntype", void 0)
    ], ListManagerModule.prototype, "SetUpdateMaster", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], ListManagerModule.prototype, "GetDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ListManagerModule.prototype, "SetDetails", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof DetailModel !== "undefined" && DetailModel) === "function" ? _j : Object]),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], ListManagerModule.prototype, "AddDetail", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof IDetailDTO !== "undefined" && IDetailDTO) === "function" ? _l : Object]),
        __metadata("design:returntype", void 0)
    ], ListManagerModule.prototype, "SetAddDetail", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof IDetailDTO !== "undefined" && IDetailDTO) === "function" ? _m : Object]),
        __metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
    ], ListManagerModule.prototype, "UpdateDetail", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_p = typeof IDetailDTO !== "undefined" && IDetailDTO) === "function" ? _p : Object]),
        __metadata("design:returntype", void 0)
    ], ListManagerModule.prototype, "SetUpdateDetail", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_q = typeof Promise !== "undefined" && Promise) === "function" ? _q : Object)
    ], ListManagerModule.prototype, "DeleteMaster", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_r = typeof Promise !== "undefined" && Promise) === "function" ? _r : Object)
    ], ListManagerModule.prototype, "DeleteDetail", null);
    ListManagerModule = __decorate([
        Module({ dynamic: true, store: store, name: "listManager", namespaced: true })
    ], ListManagerModule);
    return ListManagerModule;
})();
export const AppListModule = getModule(ListManagerModule);
